import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoadingComponent from "../../common/LoadingComponent";
import './styles.css';
import { singleLinePassword } from '../../common/RegexValidation';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }
  state = {
    password: '',
    showPassword: false,
    confirmPassword:'',
    showConfirmPassword:false,
    currentPassword:'',
    showCurrentPassword:false
  } 
  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword ,password:this.state.password})
  }

  toggleConfirmPasswordVisibility = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword ,confirmPassword:this.state.confirmPassword})
  }

  toggleCurrentPasswordVisibility = () => {
    this.setState({ showCurrentPassword: !this.state.showCurrentPassword ,currentPassword:this.state.currentPassword})
  }
  onSubmit(formData) {
    var payload = {
      id: this.props.app.user._id,
      oldPassword: formData.oldPassword,
      password: formData.password
    };
    dispatch.profile.changePassword(payload);
  }

  cancelChangePassword() {
    dispatch.profile.modalOpen(false);
  }

  render() {
    const errorLabel = <div className="customErrorLabel" />;
    const {showPassword,password,confirmPassword,showConfirmPassword,currentPassword,showCurrentPassword} = this.state;
    return (
      <div>
        <LoadingComponent active={this.props.ChgPassAsyncFunc} message="Loading..." />
        <Form noValidate
          error
          ref={ref => this.form = ref}
          onValidSubmit={this.onSubmit}
          id="profChangePass">
          <Form.Input
            name="oldPassword"
            label="Current Password"
            icon="key"
            iconPosition="left"
            type={showCurrentPassword ? "text": "password"}
            placeholder="Current Password"
            required
            errorLabel={errorLabel}
            validationErrors={{
              isDefaultRequiredValue: 'Password is required',
            }}
            id="oldPassword"
            autoFocus
            action={<Icon
              name={showCurrentPassword ? 'eye' : 'eye slash'}
              value={currentPassword}
              link
              onClick={this.toggleCurrentPasswordVisibility}
              style={{left: "auto", right: "1px"}}
            />}
          />
          <Form.Input
            name="password"
            label="New Password"
            icon="key"
            iconPosition="left"
            type={showPassword ? "text": "password"}
            value={password}
            placeholder="New Password"
            required
            errorLabel={errorLabel}
            validations={{ minLength: 8, matchRegexp: singleLinePassword, sameAsEmail: (values) => {
              return this.props.app.user.email && values.password && values.password.toLowerCase() !== this.props.app.user.email.toLowerCase();
            }}}s
            validationErrors={{
              minLength: 'Minimum of 8 characters',
              matchRegexp: 'Space not allowed',
              isDefaultRequiredValue: 'New Password is required',
              sameAsEmail: 'Password cannot be the same as your email address',
            }}
            id="newPassword"
            instantValidation
            action={<Icon
              name={showPassword ? 'eye' : 'eye slash'}
              link
              onClick={this.togglePasswordVisibility}
              style={{left: "auto", right: "1px"}}
            />}
          />
          <Form.Input
            name="confirmPassword"
            label="Confirm Password"
            icon="key"
            iconPosition="left"
            type={showConfirmPassword ? "text": "password"}
            value={confirmPassword}
            placeholder="Confirm New Password"
            required
            errorLabel={errorLabel}
            validations="equalsField:password"
            validationErrors={{
              equalsField: 'Should be same as new Password',
              isDefaultRequiredValue: 'Confirm Password is required',
            }}
            id="confirmPassword"
            instantValidation
            action={<Icon
              name={showConfirmPassword ? 'eye' : 'eye slash'}
              link
              onClick={this.toggleConfirmPasswordVisibility}
              style={{left: "auto", right: "1px"}}
            />}
          />
          {this.props.changePwdError ?
            <Message
              error
              content={this.props.changePwdError.message}
            /> : ''}

          <div className="actionInFormcy border-none pad_0" >
            <Button
              type="submit"
              id="submit"
              className="button-submit float-right mar_0">
              Save
              </Button>
            <Button
              id="cancel"
              className="button-cancel"
              onClick={this.cancelChangePassword}>
              Cancel
                </Button>
          </div>
        </Form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
    profile: state.profile,
    ChgPassAsyncFunc: state.loading.effects.profile.changePassword,
    changePwdError: state.profile.changePwdError
  };
}

const connectedChangePassword = connect(mapStateToProps)(ChangePassword);
export { connectedChangePassword as ChangePassword }; 
